<script lang="ts" setup>
import Link2 from '@/components/Button/Link2.vue'
import { type ArticleNews } from '@/utils/types'

const props = defineProps({
  reverse: {
    type: Boolean,
    default: false
  },
  rectangle: {
    type: Boolean,
    default: false
  },
  item: {
    type: Object as PropType<ArticleNews>,
    default: () => { }
  }
})

const isShow: Ref<boolean> = ref(false)

onMounted(() => {
  isShow.value = true
})
// const linkStr = ''
const linkStr = computed(
  () =>
    `/news/article/${props.item?.seo?.meta_slug || props.item.id
    }`
)
</script>

<template>
  <div class="item" :class="{ reverse: props.reverse, rectangle: props.rectangle }">
    <div class="item__left">
      <figure class="item__pic h__pic" :class="{ isShow: isShow }">
        <nuxt-link :to="linkStr">
          <Nimg :src="item?.image?.link" :title="item?.image?.title" :alt="item?.image?.alt" />
        </nuxt-link>
      </figure>
      <div class="item__box">
        <div class="item__box__text">{{ item?.brand_name }}</div>
        <div class="item__date">{{ item?.publish_date }}</div>
      </div>
    </div>
    <div class="item__right">
      <div class="item__category">{{ item?.categories?.[0]?.subject }}</div>
      <nuxt-link :to="linkStr" class="item__title" :title="item.subject">{{ item.subject }}
      </nuxt-link>
      <Link2 class="item__link circle" :to="linkStr" linkTitle="閱讀" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.item {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  column-gap: toRem(24);

  @include max-media(640) {
    grid-template-columns: repeat(4, 1fr);
  }

  &.reverse {
    @include min-media(641) {
      grid-template-areas: 'r r r r l l l l';

      .item {
        &__left {
          grid-area: l;
        }

        &__right {
          grid-area: r;
        }
      }
    }
  }

  &.rectangle {
    .item {

      &__pic {
        padding-top: 65%;
        grid-column: 1/span 3;
        position: relative;
        // img {
        //   position: relative;
        // }
      }

      &__box {
        grid-column: 4/span 1;
      }
    }
  }

  &__left {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: toRem(24);
    grid-column: 1 / span 4;

    @include max-media(640) {
      grid-row: 1;
      margin-bottom: toRem(18);
    }
  }

  &__pic {
    grid-column: 1 / span 2;
    position: relative;
    padding-top: 100%;

    @include max-media(640) {
      margin-right: toRem(-12);
    }

    img {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__box {
    grid-column: 3 / span 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: toRem(-24);
    background-color: $color-gray-3;
    color: $color-gray-1;
    word-break: break-all;
    text-align: center;
    padding: 0 toRem(10);

    @include max-media(640) {
      margin-left: toRem(-12);
    }

    &__text {
      font-size: toRem(16);
      font-weight: 500;
    }
  }

  &__date {
    font-size: toRem(12);
  }

  &__right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    grid-column: 5 / span 4;

    @include max-media(640) {
      grid-row: 2;
      grid-column: 1 / span 4;
    }
  }

  &__category {
    margin-bottom: toRem(10);
    font-size: toRem(12);
    color: $color-gray-1;
  }

  &__title {
    margin-bottom: toRem(10);
    font-size: toRem(20);
    font-weight: 500;
  }

  &__link {
    @include max-media(640) {
      margin-left: auto;
    }
  }
}
</style>
